const calculatePaymentAmount = ({
  discountedMembershipCost,
  referralCreditsUsed = 0,
  subtotal,
  donationAmount = 0,
}) => {
  const trailerCareCost = subtotal - discountedMembershipCost

  // Referral credits reduce the total amount but apply *only* to the
  // membership cost. Determine if the credits used will cover the
  // total cost of the membership. If so, charge just for the trailer
  // care package and the donation. Otherwise, simply reduce the total
  // by the referral credits used.
  const effectiveMembershipCost =
    referralCreditsUsed >= discountedMembershipCost
      ? 0
      : discountedMembershipCost - referralCreditsUsed

  return effectiveMembershipCost + trailerCareCost + donationAmount
}

export default calculatePaymentAmount
